import { Box, DialogContent, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import useDetailBulkReturnProcessing from "src/hooks/orders/bulk-return-processing/useDetailBulkReturnProcessing";
import BulkReturnListTable from "./BulkReturnListTable";

export default function BulkReturnDetail({ item }) {
  const { data: order } = useDetailBulkReturnProcessing(item?._id);

  return (
    <DialogContent>
      <Stack
        direction="column"
        gap={2}
        py={2}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={1}
        >
          <Typography>
            <strong>Ngày trả hàng: </strong> <Typography component="span"> {dayjs(order?.data?.createdAt).format("DD/MM/YYYY")}</Typography>
          </Typography>
          <Typography>
            <strong>Trạng thái: </strong> <Typography component="span"> {order?.data?.status}</Typography>
          </Typography>
          <Typography>
            <strong>Tình trạng hàng: </strong> <Typography component="span"> {order?.data?.type}</Typography>
          </Typography>
          <Typography>
            <strong>NV xử lý: </strong> <Typography component="span"> {order?.data?.createdBy?.fullName}</Typography>
          </Typography>
        </Box>
        <Box bgcolor="var(--light-grey)">
          <BulkReturnListTable
            returnedFormId={item?._id}
            confirmBtn={false}
          />
        </Box>
      </Stack>
    </DialogContent>
  );
}
